import { format } from "date-fns"
import { es } from "date-fns/locale"
import { utcToZonedTime } from "date-fns-tz"

const get_timezone = () => {
  const client_info = localStorage.getItem("WEB_APP_USER") || "{}"
  const client_timezone = JSON.parse(client_info)?.user.timezone || "America/Santiago"
  return client_timezone // "America/Santiago"
}

export const formatDate = (date: Date | string, formatString: string = "dd MMMM yyyy") => {
  try {
    let dateTemp: Date
    dateTemp = new Date(date)
    const tz_date = utcToZonedTime(dateTemp, get_timezone())
    return format(tz_date, formatString, { locale: es })
  } catch (error) {
    return "--"
  }
}

export const formatTime = (time: Date | string, formatString: string = "HH:mm") => {
  try {
    let dateTemp: Date
    if (typeof time === "object") {
      dateTemp = time
    } else {
      if (time.includes("T")) {
        dateTemp = new Date(time)
      } else {
        dateTemp = new Date(`2000-01-01T${time}`)
      }
    }

    const tz_date = utcToZonedTime(dateTemp, get_timezone())
    return format(tz_date, formatString, { locale: es })
  } catch (error) {
    return "--"
  }
}

export const formatManualTime = (time: string) => {
  try {
    let dateTemp
    if (time.includes("T")) {
      dateTemp = time.split("T")
      dateTemp = dateTemp[1]
      dateTemp = dateTemp.split(":")
      return `${dateTemp[0]}:${dateTemp[1]}`
    } else {
      dateTemp = time.split(":")
      return `${dateTemp[0]}:${dateTemp[1]}`
    }
  } catch (error) {
    return "--"
  }
}

export const formatAdvanceDate = (date: any, formatString: string = "dd MMMM yyyy") => {
  try {
    // let dateTemp: Date
    // if (typeof date === "object") {
    //   dateTemp = date
    // } else {
    //   const purgeDate = date.split("T")
    //   const purgeHour = purgeDate[1].split(".")[0]
    //   const [year, month, day] = purgeDate[0].split("-").map(Number)
    //   const [hour, minute, second] = purgeHour.split(":").map(Number)
    //   dateTemp = new Date(year, month - 1, day, hour, minute, second)
    // }
    const tz_date = utcToZonedTime(Date.parse(date), get_timezone())
    return format(tz_date, formatString, { locale: es })
  } catch (error) {
    throw error
  }
}
 